import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Seguro Darknet · Protección Inteligente</p>
        <h1>Bienvenido a Seguro Darknet.</h1>
        <p className="lede">
          Su seguridad en línea es nuestra prioridad. Ofrecemos soluciones de seguro adaptadas a las necesidades del mundo digital, protegiendo su información y activos en la red oscura.
        </p>
        <div className="cta-row">
          <a href="/learn-more" target="_blank">
            Aprende Más
          </a>
          <a href="/contact" target="_blank" className="secondary">
            Contáctanos
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Protección Rápida</h2>
          <p>
            Obtenga cobertura instantánea para sus activos digitales. Con Seguro Darknet, su tranquilidad está a solo un clic de distancia.
          </p>
        </article>
        <article>
          <h2>Personalización Total</h2>
          <p>
            Adapte su póliza a sus necesidades específicas. Ofrecemos opciones flexibles para garantizar que esté completamente protegido.
          </p>
        </article>
        <article>
          <h2>Actualizaciones Automáticas</h2>
          <p>
            Mantenga su cobertura al día con nuestras actualizaciones automáticas, asegurando que siempre esté protegido contra las últimas amenazas.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;